export default __webpack_public_path__ + "static/media/coco-robot.732f6b83.png";